export default __webpack_public_path__ + "static/media/LOGO_OHANA.506958b9.png";